import { render, staticRenderFns } from "./addressManagement.vue?vue&type=template&id=21a54382&scoped=true"
import script from "./addressManagement.vue?vue&type=script&lang=js"
export * from "./addressManagement.vue?vue&type=script&lang=js"
import style0 from "./addressManagement.vue?vue&type=style&index=0&id=21a54382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a54382",
  null
  
)

export default component.exports